import React from 'react'

const Required = (isShown:any) => {
    return(
        <div className='required-input'> {!isShown.isShown ? 'This field is required' : '' }</div>
    ) 
}

export default Required;